import {
  getIndividualPageData,
  getPageInfo,
} from '@/api/global';
import Typography from '@mui/material/Typography';
import Head from 'next/head';

import Banner from '@/components/03_organisms/Banner/index.js';
import { Banner6 } from '@/helpers/nodes_data';
import HomeAndVacation from '@/components/03_organisms/HomeAndVacationCTA/HomeAndVacation';
import HomesOfBaywood from '@/components/03_organisms/HomesOfBaywood/HomesOfBaywood';
import GolfPrograms from '@/components/03_organisms/GolfPrograms/GolfPrograms';
import GolfExperience from '@/components/03_organisms/GolfExperience/GolfExperience';
import MoreInfoCarousel from '@/components/03_organisms/MoreInfoCarousel/MoreInfoCarousel';

export async function getServerSideProps(context) {
  let initialProps = {
    statusCode: 200,
  };

  let data = null;
  // Homepage NID in Drupal:
  const nid = 1;

  try {
    if (nid && !isNaN(nid)) {
      // Listing data about currently opened listing.
      data = await getPageInfo(`/baywoodgreens-homepage`);

      if (data && data.page?.jsonapi) {
        const node_data = await getIndividualPageData(
          data.page.jsonapi.individual
        );
        if (node_data) {
          initialProps = { ...initialProps, ...node_data };
        }
      }

      // Merge initially defined props with response from the backend.
      initialProps = { ...initialProps, ...data };
    }
    if (!data) {
      return {
        notFound: true,
      };
    }
  }
  catch (e) {
    console.warn('HOMEPAGE retrieval error:', e);
    // Pass status code as internal properly. It is being checked inside of
    // render() method of _app.js.
    initialProps.statusCode = 500;

    // In case of Server Side Rendering, we want the server to throw the
    // correct error code.
    // if (res) {
    //   res.statusCode = 500;
    // }
  }

  return {
    props: { ...initialProps }, // will be passed to the page component as props
    // notFound: true, // https://github.com/vercel/next.js/discussions/11862,
    // https://stackoverflow.com/questions/67946219/throw-new-errorfailed-to-load-static-props-when-setting-fallback-true-i/67946220#67946220
  };
}

export default function Home(props) {
  let node_data, body, body_json, para, paraTop;
  if (typeof document !== 'undefined') {
    document?.body?.classList?.add('homepage');
  }

  if (props) {
    node_data = props?.page_data;
    if (node_data) {
      ({ body, body_json, para, paraTop } = node_data);
    }
  }

  return (
    <div>
      <Head>
        {/* Homepage-only tracking scripts */}
        {/* Global site tag (gtag.js) - Google Ads: AW-771000809 */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=AW-771000809" />
        <script
          dangerouslySetInnerHTML={{
            __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'AW-771000809');
            `,
          }}
        />

        {/* Cloudflare Web Analytics beacon */}
        <script
          type="module"
          src="https://static.cloudflareinsights.com/beacon.min.js/v4513226cdae34746b4dedf0b4dfa099e1781791509496"
          integrity="sha512-ZE9pZaUXND66v380QUtch/5sE9tPFh2zg45pR2PB0CVkCtOREv2AJKkSidISWkysEuQ0EH8faUU5du78bx87UQ=="
          data-cf-beacon='{"version":"2024.11.0","token":"163824fff0fd41bca3dbf26843456796"}'
          crossOrigin="anonymous"
        />
      </Head>
      <main>
        {!node_data && (
          <>
            <Typography variant="h1" className={`page-title`}>
              Welcome to Baywoods!
            </Typography>
            <Typography component={`p`}>
              You’ll feel it the moment you enter the community. The tree lined
              streets, lush landscaping and brick walkways. With its magnificent
              Clubhouse as it’s centerpiece, the feeling is traditional and
              memorable. Then there’s the world class Baywood Greens golf course
              that winds it way through the community creating backyard vistas
              like nothing else around. And if that weren’t enough, there’s
              marinas with boat slips with access to Rehoboth Bay and the
              Atlantic Ocean, beaches, restaurants and shopping all just minutes
              away.
            </Typography>
          </>
        )}
        <Banner node={{ ...node_data, ...Banner6 }} />
        <HomeAndVacation node={node_data} />
        <div
          style={{
            paddingLeft: '80px',
            paddingRight: '80px',
          }}
        >
          <HomesOfBaywood node={node_data} />
        </div>
        <GolfExperience node={node_data} />
        <div
          style={{
            paddingLeft: '80px',
            paddingRight: '80px',
          }}
        >
          <GolfPrograms node={node_data} />
        </div>
        <MoreInfoCarousel node={node_data} />
      </main>
    </div>
  );
}
